// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3Ob77","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__3BSO3"};